import { Suspense, lazy } from 'react';
import classnames from 'classnames';

const OtpInput = lazy(() => import('react-otp-input'));

const inputClassName = classnames(
  'border',
  'border-input-border-color',
  'bg-input-background-color',
  'rounded',
  '!w-full',
  'focus:outline-none',
  'focus:text-input-text-color',
  'focus:border',
  'focus:border-input-focus-color',
  'h-10'
);

interface Props {
  onChange: (otp: string) => void;
  value: string;
}

const Otp = ({ onChange, value }: Props) => (
  <div className="flex flex-row items-center">
    <Suspense>
      <OtpInput
        shouldAutoFocus
        value={value}
        onChange={onChange}
        numInputs={6}
        inputStyle={inputClassName}
        renderSeparator={<span className="w-12" />}
        renderInput={(props, i) => (
          <input data-testid={`otp-${i}`} id={`otp-${i}`} {...props}></input>
        )}
      />
    </Suspense>
  </div>
);

export default Otp;
